let route = {
    path: '/modules/order-md',
    name: 'order-md-order',
    component: () => import('@/modules/order-md/index.vue'),
    children: [
        {
            path: 'order',
            name: 'order-md-management',
            component: () => import('@/modules/order-md/order.vue'),
            meta: {
                pageTitle: '门店订货单',
            }
        },
        {
            path: 'invoice',
            name: 'order-md-invoice',
            component: () => import('@/modules/order-md/invoice.vue'),
            meta: {
                pageTitle: '门店发货单',
            }
        },
        {
            path: 'delivery',
            name: 'order-delivery',
            component: () => import('@/modules/order/delivery.vue'),
            meta: {
                pageTitle: '出库单',
            }
        },
        // {
        //     path: 'createOrder',
        //     name: 'order-management-createOrder',
        //     component: () => import('@/modules/order/createOrder.vue'),
        //     meta: {
        //         pageTitle: '创建订单',
        //         parent: '/modules/order/order',
        //     }
        // },
        {
            path: 'invoiceDetail',
            name: 'order-management-invoiceDetail',
            component: () => import('@/modules/order/orderDetail/invoiceDetail.vue'),
            meta: {
                parent: '/modules/order/invoice',
            }
        },
        {
            path: 'deliveryDetail',
            name: 'order-management-deliveryDetail',
            component: () => import('@/modules/order/orderDetail/deliveryDetail.vue'),
            meta: {
                parent: '/modules/order/delivery',
            }
        },
        {
            path: 'orderDetail',
            name: 'order-management-detail',
            component: () => import('@/modules/order/orderDetail/orderDetail.vue'),
            meta: {
                parent: '/modules/order/order',
            }
        },
        {
            path: 'storeOrder',
            name: 'store-order',
            component: () => import('@/modules/order/store/order.vue'),
            meta: {
                pageTitle: '门店订单',
            }
        },
        {
            path: 'createStoreOrder',
            name: 'store-order-management-createOrder',
            component: () => import('@/modules/order/store/createOrder.vue'),
            meta: {
                pageTitle: '创建门店订单',
                parent: '/modules/order/store/storeOrder',
            }
        },
        {
            path: 'storeOrderDetail',
            name: 'store-order-management-detail',
            component: () => import('@/modules/order/store/orderDetail/index.vue'),
            meta: {
                parent: '/modules/order/order',
            }
        }
    ],
    meta: {
        role: 'xurui_admin'
    }
};
export const OrderMdRouter = route;
